import { Fragment, useCallback, useState } from "react";
import { Container, Row } from "reactstrap";
import { FontAwesomeIconTitle, Icons } from "../../../constants";
import IconMarkUp from "../common/IconMarkUp";
import FontAwesomeBody from "./FontAwesomeBody";
import Breadcrumbs from "../../../coreComponents/breadcrumbs";
import { FontAwesomeData } from "../../../data/icons/FontAwesomeIcon";

const FontAwesomeIconContainer = () => {
  const [iconTag, setIconTag] = useState({ iconTag: "" });
  const [icon, setIcon] = useState({ icon: "" });
  const [iconFClass, setIconFClass] = useState({ iconFClass: "" });
  const callback = useCallback((tag: string) => {
    setIconTag({
      iconTag: '<i className="fa fa-' + tag + '"></i>',
    });
    setIcon({
      icon: "fa fa-" + tag + " fa-2x",
    });
    setIconFClass({
      iconFClass: "fa fa-" + tag,
    });
  }, []);
  return (
    <>
      <Breadcrumbs mainTitle={FontAwesomeIconTitle} parent={Icons} />
      <Container fluid>
        <Row>
          {FontAwesomeData.map((data, i) => (
            <FontAwesomeBody key={i} iconType={data.data} title={data.title} parentCallback={callback} />
          ))}
        </Row>
      </Container>
      <IconMarkUp iconTag={iconTag} icon={icon} iconFClass={iconFClass} />
    </>
  );
};

export default FontAwesomeIconContainer;
